var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfFormControlBox", {
    staticClass: "ds-date-picker",
    attrs: {
      owner: _vm._self,
      "block-class": { "ds-error-border": _vm.errors.length > 0 },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "simple",
          fn: function () {
            return [
              _c(
                "span",
                {
                  attrs: {
                    title: _vm._f("proxy")(_vm.getShowContent(), _vm.formatter),
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm._f("proxy")(_vm.getShowContent(), _vm.formatter))
                  ),
                ]
              ),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(" " + _vm._s(_vm.errorsMsg) + " "),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "content",
          fn: function () {
            return [
              !_vm.readOnly
                ? _c("el-date-picker", {
                    ref: "datePicker",
                    attrs: {
                      disabled: _vm.disabled,
                      type: _vm.$chooseType,
                      editable: _vm.isInput,
                      format: _vm.$timeFormat,
                      clearable: _vm.clearable,
                      placeholder: _vm.placeholder,
                      "picker-options": _vm.mPicker || _vm.pickerOptions,
                      "value-format": _vm.valueFormat,
                    },
                    on: { focus: _vm.pickerShow, change: _vm.dateChange },
                    model: {
                      value: _vm.value2,
                      callback: function ($$v) {
                        _vm.value2 = $$v
                      },
                      expression: "value2",
                    },
                  })
                : _vm.readOnly
                ? _c("div", { staticClass: "ds-form-readonly" }, [
                    _c(
                      "span",
                      {
                        attrs: {
                          title: _vm._f("proxy")(
                            _vm.getShowContent(),
                            _vm.formatter
                          ),
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("proxy")(_vm.getShowContent(), _vm.formatter)
                          )
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(" " + _vm._s(_vm.errorsMsg) + " "),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }